import React, { useState, useEffect } from "react";
import { onAuthStateChanged, signOut } from "firebase/auth";
import { auth } from "./firebase";
import './App.css';

import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate } from "react-router-dom";
import Header from "./components/Header";
import Login from "./components/Login";
import Signup from "./components/Signup";
import Pomodoro from "./components/Pomodoro";
import ScheduledTaskBox from "./components/ScheduledTaskBox";
import TaskCalendar from "./components/TaskCalendar";
import DashboardEdit from "./components/DashboardEdit"; 
import Analiticas from "./components/Analiticas"; 
import CookieBanner from "./components/CookieBanner";
import Streak from "./components/Streak";
import { NotixProvider } from "./components/Notix/Notix";
import LandingPage from "./components/LandingPage";


// Dashboard principal como componente aparte
function Dashboard({
  user, handleLogout, handleDashboardEdit, dashboardConfig, handleConfigChange, showDashboardEdit, setShowDashboardEdit
}) {
  return (
    <>
      <Header
        user={user}
        onLogout={handleLogout}
        onLoginClick={() => {}}
        onSignupClick={() => {}}
        onDashboardEdit={handleDashboardEdit}
      />
      <div className="main-content">
        <div className="top-section">
          {dashboardConfig.showPomodoro && <Pomodoro />}
        </div>
        <div className="bottom-section">
          {dashboardConfig.showTasks && (
            <div className="left-column">
              <Streak />
              <ScheduledTaskBox />
              {dashboardConfig.showAnaliticas && (
                <div style={{ marginTop: "2rem", width: "100%" }}>
                  <Analiticas />
                </div>
              )}
            </div>
          )}
          {dashboardConfig.showCalendar && (
            <div className="right-column">
              <TaskCalendar />
            </div>
          )}
        </div>
      </div>
      <DashboardEdit 
        isOpen={showDashboardEdit}
        onClose={() => setShowDashboardEdit(false)}
        config={dashboardConfig}
        onConfigChange={handleConfigChange}
      />
      <CookieBanner />
    </>
  );
}

function App() {
  const [user, setUser] = useState(null);
  const [showDashboardEdit, setShowDashboardEdit] = useState(false);
  const [authChecked, setAuthChecked] = useState(false); 
  const [dashboardConfig, setDashboardConfig] = useState(() => {
    const savedConfig = localStorage.getItem('dashboardConfig');
    return savedConfig ? JSON.parse(savedConfig) : {
      showPomodoro: true,
      showTasks: true,
      showCalendar: true,
      showAnaliticas: true,
    };
  });

  useEffect(() => {
    localStorage.setItem('dashboardConfig', JSON.stringify(dashboardConfig));
  }, [dashboardConfig]);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      setAuthChecked(true); // Ya sabemos el estado de auth
    });
    return () => unsubscribe();
  }, []);

  const handleLogout = async () => {
    try {
      await signOut(auth);
    } catch (error) {
      console.error("Error cerrando sesión:", error);
    }
  };

  const handleDashboardEdit = () => {
    setShowDashboardEdit(true);
  };

  const handleConfigChange = (newConfig) => {
    setDashboardConfig(newConfig);
  };

  // Loader mientras Firebase responde
  if (!authChecked) {
    return (
      <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <span>Cargando...</span>
      </div>
    );
  }

  return (
    <NotixProvider>
      <Router>
        <Routes>
          <Route path="/login" element={
            user ? <Navigate to="/app" replace /> : <Login />
          } />
          <Route path="/signup" element={
            user ? <Navigate to="/app" replace /> : <Signup />
          } />
          <Route path="/app" element={
            user ? (
              <Dashboard
                user={user}
                handleLogout={handleLogout}
                handleDashboardEdit={handleDashboardEdit}
                dashboardConfig={dashboardConfig}
                handleConfigChange={handleConfigChange}
                showDashboardEdit={showDashboardEdit}
                setShowDashboardEdit={setShowDashboardEdit}
              />
            ) : (
              <Navigate to="/login" replace />
            )
          } />
          <Route path="/home" element={<LandingPage />} />
          <Route path="/" element={<Navigate to="/home" replace />} />
          <Route path="*" element={
            user ? <Navigate to="/app" replace /> : <Navigate to="/login" replace />
          } />
        </Routes>
      </Router>
    </NotixProvider>
  );
}

export default App;